import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import { Warning, Close } from "@mui/icons-material";
import GenericActionButton from "./GenericActionButton";

const UnsavedDataConfirmationDialog = ({
  open,
  onClose,
  onDiscardChanges,
  title = "Unsaved Changes",
  message = "You have unsaved changes. Are you sure you want to discard them?",
  discardButtonText = "Discard Changes",
  cancelButtonText = "Cancel",
  showWarningIcon = true,
}) => {
  const handleDiscardChanges = () => {
    onDiscardChanges();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: "200px",
        },
      }}
    >
      <DialogTitle>
          <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
            {showWarningIcon && (
              <Warning
                sx={{
                  mr: 1,
                  color: "warning.main",
                  fontSize: "20px",
                }}
              />
            )}
            <Typography
              sx={{
                fontWeight: "bold",
                color: "text.primary",
              }}
            >
              {title}
            </Typography>
          </Box>
      </DialogTitle>

      <DialogContent dividers sx={{ pb: 2 }}>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <GenericActionButton
          label={cancelButtonText}
          variant="outlined"
          color="inherit"
          onClick={handleCancel}
        />
        <GenericActionButton
          label={discardButtonText}
          onClick={handleDiscardChanges}
          variant="contained"
          color="error"
        />
        {/* <Button
          onClick=
          variant="outlined"
          color="primary"
          sx={{
            minWidth: "100px",
            fontWeight: "medium",
          }}
        >
          {cancelButtonText}
        </Button>
        <Button
          onClick={handleDiscardChanges}
          variant="contained"
          color="warning"
          sx={{
            minWidth: "100px",
            fontWeight: "medium",
            backgroundColor: "warning.main",
            "&:hover": {
              backgroundColor: "warning.dark",
            },
          }}
        >
          {discardButtonText}
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedDataConfirmationDialog;
